import './App.css';
import theme from './components/Theme';
import { ThemeProvider } from '@mui/material';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';

import AdminLoginScreen from './screens/AdminLoginScreen';
import LoungeAccessScreen from './screens/LoungeAccessScreen';
import LoungeSurveyScreen from './screens/LoungeSurveyScreen';
import LoungeSurveyThankYouScreen from './screens/LoungeSurveyThankYouScreen';
import RecentSessionsScreen from './screens/RecentSessionsScreen';
import SurveyScreen from './screens/SurveyScreen';
import setAdminAuthToken from './utils/setAdminAuthToken';

import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from './lib/queryClient';
// import AdminHeader from './components/AdminHeader';
import ThankYouSurveyScreen from './screens/ThankYouSurveyScreen';
import isTokenValid from './utils/isTokenValid';
import { logout } from './actions/adminUserActions';
import HomeScreen from './screens/HomeScreen';
import PersistentDrawerLeft from './components/PersistentDrawerLeft';
import SessionSurveyResultScreen from './screens/SessionSurveyResultScreen';

import SessionSurveyDetailedResultScreen from './screens/SessionSurveyDetailedResultScreen';
import ReviewTimelineScreen from './screens/ReviewTimelineScreen';

if (localStorage.adminUserInfo) {
  setAdminAuthToken(JSON.parse(localStorage.adminUserInfo).token);
}

function App() {
  // Using 'any' type for dispatch during migration - will be properly typed in Phase 5
  const dispatch: any = useDispatch();

  const adminUserLogin = useSelector((state: any) => state.adminUserLogin);
  const { adminUserInfo } = adminUserLogin;

  useEffect(() => {
    if (localStorage.adminUserInfo) {
      const isAdminTokenValid = isTokenValid(
        JSON.parse(localStorage.adminUserInfo).token,
      );
      if (!isAdminTokenValid) {
        dispatch(logout());
      }
    }
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={theme}>
        <Router>
          {adminUserInfo && (
            <>
              <PersistentDrawerLeft />
              {/* <AdminHeader theme={theme} /> */}
            </>
          )}

          <Routes>
            {!adminUserInfo && (
              <>
                <Route
                  path="/admin-login"
                  element={<AdminLoginScreen />}
                ></Route>
                <Route
                  path="/lounge-access"
                  element={<LoungeAccessScreen />}
                ></Route>
                <Route
                  path="/lounge-survey"
                  element={<LoungeSurveyScreen />}
                ></Route>
                <Route
                  path="/lounge-survey/thank-you"
                  element={<LoungeSurveyThankYouScreen />}
                ></Route>
              </>
            )}
            {adminUserInfo && (
              <>
                <Route path="/" element={<HomeScreen />}></Route>
                <Route
                  path="/session-review"
                  element={<RecentSessionsScreen />}
                ></Route>
                <Route
                  path="/session-review/review-timeline"
                  element={<ReviewTimelineScreen />}
                ></Route>
                <Route
                  path="/session-review/result"
                  element={<SessionSurveyResultScreen />}
                ></Route>
                <Route
                  path="/session-review/detailed-result"
                  element={<SessionSurveyDetailedResultScreen />}
                ></Route>
                <Route
                  path="/session-review/:id"
                  element={<SurveyScreen />}
                ></Route>

                <Route
                  path="/session-review/thank-you"
                  element={<ThankYouSurveyScreen />}
                ></Route>
              </>
            )}
            <Route
              path="*"
              element={<Navigate to={adminUserInfo ? '/' : '/admin-login'} />}
            />
          </Routes>
        </Router>
      </ThemeProvider>
    </QueryClientProvider>
  );
}

export default App;
